import { getBalance, } from '../../actions/getBalance.js';
import { getBlock, } from '../../actions/getBlock.js';
import { getBlockCount, } from '../../actions/getBlockCount.js';
import { getBlockStats, } from '../../actions/getBlockStats.js';
import { getTransactionFee, } from '../../actions/getTransactionFee.js';
import { getTransactions, } from '../../actions/getTransactions.js';
import { getUTXOs, } from '../../actions/getUTXOs.js';
import { getUTXOTransaction, } from '../../actions/getUTXOTransaction.js';
export function publicActions(client) {
    return {
        getBalance: (args) => getBalance(client, args),
        getBlock: (args) => getBlock(client, args),
        getBlockCount: () => getBlockCount(client),
        getBlockStats: (args) => getBlockStats(client, args),
        getTransactions: (args) => getTransactions(client, args),
        getUTXOTransaction: (args) => getUTXOTransaction(client, args),
        getUTXOs: (args) => getUTXOs(client, args),
        getTransactionFee: (args) => getTransactionFee(client, args),
    };
}
//# sourceMappingURL=public.js.map